import { Schema as S } from "effect";

const CreatedPatientReference = S.Struct({
  _id: S.String,
});

const CreatedPatientResult = S.Union([S.String, CreatedPatientReference]);

/**
 * Decodes the patient identifier shapes returned by supported DocCirrus versions.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * import { Schema } from "effect";
 *
 * Schema.decodeUnknownSync(CreatePatientResponseSchema)(["patient-1"]);
 * ```
 */
export const CreatePatientResponseSchema = S.Union(
  [CreatedPatientResult,
  S.NonEmptyArray(CreatedPatientResult)],
);

/**
 * Decoded result of a DocCirrus patient-creation request.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const response: CreatePatientResponse = ["patient-1"];
 * ```
 */
export type CreatePatientResponse =
  S.Schema.Type<typeof CreatePatientResponseSchema>;
